// ABOUTME: Three circles that grow and shrink in sequence
// ABOUTME: SVG adapted from react-loading (MIT); fill comes from the surrounding element
import * as React from 'react';
import Bubble from './Bubble';

const Bubbles: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <Bubble x={8} begin="0" />
    <Bubble x={16} begin="0.3" />
    <Bubble x={24} begin="0.6" />
  </svg>
);

export default Bubbles;
